export default __webpack_public_path__ + "static/media/step_008.eeb5ac45.jpeg";